// Выбор языка интерфейса. Стоит справа от названия приложения в тулбаре.
import type { ChangeEvent, ReactElement } from 'react';
import { useI18n } from './I18nProvider';
import { LANGS, LANG_META, type Lang } from './translations';
import styles from './LanguagePicker.module.css';

export function LanguagePicker(): ReactElement {
  const { lang, setLang, t } = useI18n();

  function handleChange(e: ChangeEvent<HTMLSelectElement>): void {
    setLang(e.target.value as Lang);
  }

  return (
    <select
      className={`select ${styles.picker}`}
      value={lang}
      onChange={handleChange}
      aria-label={t('app.language')}
      title={t('app.language')}
    >
      {/* В списке только флаг: название языка живёт в подсказке и aria-label
          самого select, иначе строка распухает и ломает узкую полосу. */}
      {LANGS.map((code) => (
        <option key={code} value={code} title={LANG_META[code].name}>
          {LANG_META[code].flag}
        </option>
      ))}
    </select>
  );
}
